import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { Observable } from 'rxjs/Observable';
import { ErrorsService } from '../../utils/services/errors.service';

@Injectable()
export class NonAdherenceListService {

  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) { }

  /**API request to list locked Employee */
  getLockedList(pageNumber): Observable<any> {
    return this.httpService.post(`employee/listLockedEmployees`, '')
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**API request to unlock employee */
  unLockTimeSheet(employees): Observable<any> {
    const data = {
      'employeeList': employees,
    };
    return this.httpService.post(`employee/unlock`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**function to handle error service */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/non-adherence-list/non-adherence-list.service.ts